const SOURCE_LABELS: Record<string, string> = {
	chain_hospital_average: "Chain hospital average",
	hospital_group_average: "Hospital group average",
	previous_comparable_period: "Previous comparable period",
	kpi_target: "KPI target",
	hospital_revenue_share_by_doctors: "Hospital revenue share (by doctors)",
	hospital_revenue_proportional_by_doctor_count: "Hospital average (by doctor count)",
	department_doctor_average: "Department doctor average",
	hospital_doctor_average: "Hospital doctor average",
};

/** Hide internal benchmark source keys / UUIDs from operators. */
export function formatBenchmarkSource(source: string | null | undefined): string {
	if (!source?.trim()) return "—";
	const raw = source.trim();
	if (SOURCE_LABELS[raw]) return SOURCE_LABELS[raw];

	if (raw.startsWith("chain_group:")) return "Chain hospital average";
	if (raw.startsWith("hospital_group:")) return "Hospital group average";

	const peerParts = raw.split(":");
	if (peerParts[0] === "peer_group") {
		const name = peerParts.slice(2).join(":").trim() || peerParts[1]?.trim();
		if (name && !/^[0-9a-f-]{36}$/i.test(name)) {
			return `${name} peer average`;
		}
		return "Peer group average";
	}

	if (raw.startsWith("kpi_target:")) {
		const period = raw.slice("kpi_target:".length).trim();
		return period ? `KPI target (${period})` : SOURCE_LABELS.kpi_target;
	}

	return raw.replace(/_/g, " ");
}
